"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterSearch = function FilterSearch() {
  return _react2.default.createElement(
    "g",
    { id: "filter-search", fillRule: "evenodd" },
    _react2.default.createElement("path", {
      d: "M85.012 142.345c29.761-45.058 90.587-57.574 135.86-27.954 45.272 29.62 57.848 90.157 28.087 135.215-29.759 45.057-90.587 57.573-135.857 27.954-45.275-29.618-57.85-90.158-28.09-135.215m191.312 123.857c39.977-60.524 23.086-141.844-37.729-181.63-60.813-39.786-142.518-22.975-182.494 37.55-36.962 55.962-25.276 129.674 24.76 171.923-4.405 1.392-8.378 4.225-11.101 8.345L3.41 402.85c-6.303 9.543-3.615 22.483 5.974 28.756 9.588 6.276 22.592 3.598 28.895-5.945l66.35-100.457c2.72-4.122 3.76-8.874 3.296-13.453 58.812 28.964 131.439 10.413 168.399-45.548M474.92 176c13.244 0 24.08-10.575 24.08-23.5S488.164 129 474.92 129H325a141.762 141.762 0 0 1 15.044 47h134.875zM476.836 248H332.155c-6.23 17-15.513 32.533-27.155 46h171.836c12.74 0 23.164-10.35 23.164-23s-10.424-23-23.164-23M476.968 366H183.032C170.365 366 160 376.35 160 389s10.365 23 23.032 23h293.936C489.635 412 500 401.65 500 389s-10.365-23-23.032-23"
    })
  );
};

exports.default = FilterSearch;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/FilterSearch.js
// module id = 2955
// module chunks = 4